import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";

export function getServicesHire(tenant: Tenant): ServiceCardItem[] {
	return [
		{
			title: "Pronájem specialisty",
			desc: "Půjčíme vám jednoho konkrétního odborníka (např. programátora, testera manažera, team leadera nebo analytika).",
			iconName: brackets,
			show: true,
		},
		{
			title: "Pronájem malého týmu",
			desc: "Na smluvené období od nás dostanete malý tým (nejčastěji 3–4 specialisté), který bude dohromady pracovat na vašem projektu.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Doplnění vašich kapacit",
			desc: "Máte interní tým, ale potřebujete ho dočasně doplnit? Pronajmeme vám jednoho či více profíků, kteří budou spolupracovat s vaším týmem.",
			iconName: brackets,
			show: true,
		},
	];
}
